import React from 'react';

import HomePage from 'features/home/pages/home-page';
import { StyleSheet } from 'react-native';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { Box } from 'components/ui';
import { useIsNativeTabBarEnabled } from 'hooks/use-is-native-tab-bar-enabled';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { t } from 'state/intl/translations';
import { useLoyaltyUserState } from 'state/loyalty/hooks/use-loyalty-user-state';
import { primitive } from 'styles/constants';

export default function HomeRoute() {
  const { triggerSignInAccessibility } = useAuthFlow();
  const signInAccessibilityMsg = triggerSignInAccessibility ? t('visuallyHiddenSignInSuccess') : '';
  const isDesktopWeb = useIsDesktopWebBreakpoint();
  const isNativeTabBarEnabled = useIsNativeTabBarEnabled();

  useLoyaltyUserState({ refreshOnMountOrFocus: true });

  return (
    <Box
      style={styles.container}
      testID="homepage"
      accessibilityLabel={signInAccessibilityMsg}
      accessibilityRole="alert"
    >
      {isNativeTabBarEnabled ? (
        <StandardMobileHeader hideTsm={!isDesktopWeb} useNativeTabsRootSafeAreaInset />
      ) : null}
      <HomePage />
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: primitive.$mayoEggWhite,
    flex: 1,
  },
});
